export default __webpack_public_path__ + "static/media/mail_black_24dp.7a53cace.svg";